import * as blUrls from 'lib/urls'
import CallToActionBox from './call-to-action-box'
import { ASSETS_BASE_URL } from 'shared/constants'

export const CreateBabylistCTA = () =>
  CallToActionBox({
    img: `${ASSETS_BASE_URL}/assets/store/mobile.svg`,
    title: 'Create a Babylist',
    body: 'Just a couple of steps to start adding items to your registry.',
    buttonText: 'Get Started',
    href: blUrls.newRegistryPath,
  })

export const FindBabylistCTA = () =>
  CallToActionBox({
    img: `${ASSETS_BASE_URL}/assets/store/gift.svg`,
    title: 'Find a Babylist',
    body: 'Give the perfect gift to the new family.',
    buttonText: 'Find Registry',
    buttonVariant: 'info',
    href: blUrls.findPath,
  })

export default CallToActionBox
